import { Redirect, Route } from 'react-router-dom';
import { useAbility } from '@casl/react';

import { menuPermissions } from 'configs/menuConfig';
import { AbilityContext } from 'configs/CASLContext';
import { Forbidden } from 'pages/Forbidden';
import { useAuth } from 'providers/AuthenticationProvider';
import BaseUrl from '../constant/baseUrl';

export const SecuredRoute = (props) => {
    const { isLogged } = useAuth();
    const ability = useAbility(AbilityContext);

    if (isLogged) {
        const pageId = props.path?.length > 0 && props.path.substring(1);
        const permissions = menuPermissions[pageId];

        if (permissions?.length > 0) {
            if (
                permissions.some((permission) =>
                    ability.rules.some((rule) => rule.subject === permission.subject)
                )
            ) {
                return <Route path={props.path} component={props.component} />;
            } else {
                return <Route path={props.path} component={Forbidden} />;
            }
        } else {
            return <Route path={props.path} component={Forbidden} />;
        }
    } else {
        return <Redirect to={BaseUrl.Login} />;
    }

    return <div></div>;
};
